
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34556',
  depVersions: {
  "documents-public-ui": "static-1.34556",
  "atom": "static-1.5083",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2507",
  "client-types": "static-1.466",
  "cssUtils": "static-1.794",
  "customer-data-filters-ui": "static-1.39844",
  "customer-data-objects": "static-1.7681",
  "customer-data-property-utils": "static-1.8102",
  "documents-lib": "static-1.34561",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.338",
  "FormsCommonComponents": "static-1.85898",
  "FormUrlGenerator": "static-2.4730",
  "foundations-theming-specialty": "static-1.2146",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5603",
  "hs-test-utils": "static-1.8025",
  "hub-http": "static-1.6233",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11789",
  "HubStyleTokens": "static-2.11482",
  "I18n": "static-7.1628",
  "icons": "static-2.648",
  "jasmine-immutable": "static-1.3033",
  "jasmine-runner": "static-1.6475",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7167",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5411",
  "quartz": "static-1.7048",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5351",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8182",
  "reference-resolvers-lite": "static-1.8106",
  "reporting-data": "static-1.67611",
  "reporting-reports": "static-1.67289",
  "reporting-snowflake": "static-1.56229",
  "reporting-testing-lib": "static-1.9544",
  "reporting-visualizations": "static-1.59687",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8953",
  "sanitize": "static-1.4487",
  "sanitize-text": "static-1.8152",
  "self-service-api": "static-1.10258",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1758",
  "signup-constants": "static-1.18862",
  "signup-ui-url-generator": "static-2.8062",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4773",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4774",
  "ui-addon-form-validation": "static-1.11000",
  "ui-asset-management-lib": "static-1.11050",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8428",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "static-1.7077",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9680",
  "foundations-components": "static-1.7962",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.826",
  "quartz-core": "static-1.6267",
  "quick-fetch": "static-1.3924",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4664",
  "ui-addon-i18n": "static-1.11160",
  "ui-addon-upgrades": "static-9.18012",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3325",
  "quartz-webpack": "static-1.3272",
  "foundations-assets": "static-1.4877",
  "foundations-theming": "static-1.4430",
  "hub-http-shared-msw-handlers": "static-1.9997",
  "hubspotter-http": "static-1.4659",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.232",
  "conversations-skeleton-state": "static-1.7258",
  "crm-message-bus": "static-1.43038",
  "customer-data-filters-ui-msw-helpers": "static-1.22279",
  "customer-data-objects-ui-components": "static-1.13039",
  "customer-data-reference-ui-components": "static-1.13176",
  "customer-data-ui-utilities": "static-1.9837",
  "framework-builder-read-service-client": "static-1.4012",
  "framework-data-schema-quick-fetch": "static-1.6801",
  "framework-data-schema-resolvers": "static-1.6896",
  "inbound-db-meta-service-client": "static-1.3593",
  "inbound-db-properties-service-client": "static-1.3853",
  "multi-account-reference-resolvers": "static-1.990",
  "onboarding-tours": "static-1.16637",
  "reporting-datasets-permissions-lib": "static-1.13730",
  "ui-addon-teams": "static-1.21571",
  "quartz-auth": "static-1.723",
  "ui-business-units-lib": "static-1.9065",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "static-1.9019",
  "ContentUtils": "static-1.68412",
  "customer-data-properties": "static-1.51602",
  "forms-ai-lib": "static-1.4337",
  "forms-utils-lib": "static-1.12610",
  "foundations-components-test-utils": "static-1.5445",
  "react-dnd-compat": "static-1.4625",
  "react-tinymce": "static-1.55288",
  "tinymce-config": "static-2.54414",
  "ui-gdpr-components": "static-1.10361",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3415",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3136",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.88",
  "ui-fonts": "static-1.744",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4338",
  "csstype": "static-1.50",
  "quartz-head": "static-1.713",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1552",
  "external-options-client-types": "static-1.4166",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.723",
  "frontend-preferences-client": "static-1.7938",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3709",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25428",
  "hubspot-apollo-client": "static-1.4891",
  "foundations-components-legacy": "static-1.987",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.478",
  "hs-story-utils": "static-1.9436",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.237",
  "timezone-utils": "static-2.5256",
  "seat-types-lib": "static-1.46",
  "bend-plugin-foundations-components": "static-1.4231",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1980",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.723",
  "quartz-tracking": "static-1.427",
  "bend-plugin-chirp-manifest": "static-1.74",
  "chirp-fetch": "static-1.1898",
  "purchase-motions-components": "static-1.5926",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4086",
  "bender-build-tools": "static-1.3205",
  "amplitude-session-replay-browser": "static-1.60",
  "bend-plugin-foundations-theming": "static-1.2913",
  "stylex": "static-1.33",
  "hs-resources": "static-1.163",
  "pulse": "static-1.586",
  "restore-request-side-panel-lib": "static-1.918",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3804",
  "crm-pipelines-api-client-types": "static-1.4145",
  "fdsr-migration-layer": "static-1.15",
  "multi-currency-client-types": "static-1.3698",
  "getting-started-shared-tasks": "static-1.18507",
  "growth-data-modal": "static-1.5448",
  "growth-onboarding-confetti": "static-1.3078",
  "growth-onboarding-next-action-utils": "static-1.1968",
  "navigation-components": "static-1.18079",
  "onboarding-tours-client": "static-1.4851",
  "onboarding-tours-utils": "static-1.703",
  "ui-shepherd-react": "static-3.10176",
  "ui-shepherd-tracker": "static-1.7557",
  "ui-universal-auth": "static-1.8992",
  "user-context": "static-1.5116",
  "hubspotter-http-shared-msw-handlers": "static-1.9995",
  "magpie-lib": "static-1.5559",
  "navigation-messaging": "static-1.7406",
  "chatspot-core": "static-1.21398",
  "copilot-toolkit": "static-1.11173",
  "cms-field-types": "static-1.4824",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16199",
  "calling-global-api": "static-1.64562",
  "calling-internal-common": "static-1.31314",
  "calling-lifecycle-internal": "static-1.65944",
  "calling-lifecycle-messages": "static-1.58238",
  "commerce-products-lib": "static-1.9623",
  "crm-links": "static-1.6304",
  "customer-data-properties-shared-msw-handlers": "static-1.9324",
  "file-manager-components": "static-1.23666",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4230",
  "meetings-icalendar-utils-lib": "static-1.643",
  "object-builder-ui-client": "static-1.48798",
  "pipeline-validation-client-types": "static-1.3972",
  "property-value-citations": "static-1.2216",
  "smart-property-lib": "static-1.7145",
  "tiered-pricing": "static-1.1249",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9069",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19857",
  "tinymce-themes": "static-1.56384",
  "data-token-picker": "static-1.16430",
  "hub-http-contrib": "static-1.3054",
  "interframe": "static-3.4770",
  "tinymce-data": "static-1.40499",
  "tinymce-plugins": "static-1.57528",
  "ui-addon-sales-email": "static-1.5222",
  "onboarding-scopes": "static-1.6472",
  "ui-addon-opt": "static-4.8377",
  "apollo-link-hub-http": "static-2.4663",
  "hubspot-apollo-cache": "static-1.350",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.184",
  "purchase-motions-api": "static-1.5929",
  "trials-service-types": "static-1.3914",
  "bend-plugin-pulse": "static-1.89",
  "directed-graph": "static-1.947",
  "event-emitter": "static-1.958",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1976",
  "growth-onboarding-next-action-components": "static-1.1996",
  "user-context-client": "static-1.4624",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5019",
  "nest": "static-1.239",
  "reactive-lib": "static-1.736",
  "simple-logging-lib": "static-1.3061",
  "unified-auth-core-lib": "static-1.788",
  "getting-started-shared-tasks-store": "static-1.17625",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13614",
  "integrations-tracking-lib": "static-1.5612",
  "native-integrations-shared-strings": "static-1.7792",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10376",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.506",
  "calling-error-reporting": "static-1.31321",
  "shared-worker-versioning": "static-1.11048",
  "calling-usage-tracker": "static-1.6553",
  "voice-sms-access-library": "static-1.1025",
  "customer-data-tracking": "static-1.6901",
  "commerce-permissions": "static-1.780",
  "products-iframe-lib": "static-1.7982",
  "products-ui-components-shared-msw-handlers": "static-1.10379",
  "location-customization-utils-lib": "static-1.9310",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4166",
  "video-components-external": "static-1.11325",
  "video-data-lib": "static-1.34983",
  "data-agent-kit": "static-1.212",
  "feedback-loader": "static-1.29318",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10080",
  "fsm": "static-1.3742",
  "policy-lib": "static-1.6789",
  "react-colorpicker": "static-2.10218",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10143",
  "FileManagerLib": "static-1.39306",
  "NamespacedHubStyle": "static-2.9065",
  "FileManagerCore": "static-1.39165",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7771",
  "layout-dnd-components": "static-1.12470",
  "layout-dnd-utils": "static-1.11445",
  "react-codemirror": "static-1.10638",
  "ui-addon-emoji-picker": "static-1.9899",
  "ui-brand-identity-lib": "static-1.15331",
  "InboxConnectUtils": "static-4.14859",
  "meetings-connect-utils-lib": "static-1.7617",
  "universal-page-editor-lib": "static-1.3024",
  "google-sheets-integration-lib": "static-1.288",
  "microsoft-drive-integration-lib": "static-1.411",
  "slack-ui-library": "static-1.10404",
  "calling-orchestration-schema": "static-1.35802",
  "sales-views-client-types": "static-1.4270",
  "crm-record-cards-service-types": "static-1.3604",
  "content-media-composition-data-lib": "static-1.12368",
  "content-media-compositions": "static-2.16375",
  "media-bridge-lib": "static-1.18950",
  "trellis-story-utils": "static-1.4526",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5933",
  "FileManagerImages": "static-1.36817",
  "video-components": "static-1.13328",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4548",
  "video-embed": "static-1.35817",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8713",
  "ui-coaching-tips": "static-1.28607",
  "ContentData": "static-1.68487",
  "layout-data-lib": "static-1.9770",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22161",
  "outpost": "static-1.4193",
  "growth-onboarding-feedback-components": "static-1.6592",
  "advanced-menus-core": "static-1.15147",
  "advanced-menus-lib": "static-1.12086",
  "ExportDialog": "static-6.10399",
  "ui-memberships-settings-lib": "static-1.34092",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15146",
  "simple-menus-lib": "static-1.16663"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34556",
  "atom": "/atom/static-1.5083",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2507",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39844",
  "customer-data-objects": "/customer-data-objects/static-1.7681",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8102",
  "documents-lib": "/documents-lib/static-1.34561",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.338",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85898",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4730",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2146",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5603",
  "hs-test-utils": "/hs-test-utils/static-1.8025",
  "hub-http": "/hub-http/static-1.6233",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11789",
  "HubStyleTokens": "/HubStyleTokens/static-2.11482",
  "I18n": "/I18n/static-7.1628",
  "icons": "/icons/static-2.648",
  "jasmine-immutable": "/jasmine-immutable/static-1.3033",
  "jasmine-runner": "/jasmine-runner/static-1.6475",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7167",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5411",
  "quartz": "/quartz/static-1.7048",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5351",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8182",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8106",
  "reporting-data": "/reporting-data/static-1.67611",
  "reporting-reports": "/reporting-reports/static-1.67289",
  "reporting-snowflake": "/reporting-snowflake/static-1.56229",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9544",
  "reporting-visualizations": "/reporting-visualizations/static-1.59687",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8953",
  "sanitize": "/sanitize/static-1.4487",
  "sanitize-text": "/sanitize-text/static-1.8152",
  "self-service-api": "/self-service-api/static-1.10258",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1758",
  "signup-constants": "/signup-constants/static-1.18862",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8062",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4773",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4774",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11000",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11050",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8428",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "/viral-links-lib/static-1.7077",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9680",
  "foundations-components": "/foundations-components/static-1.7962",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.826",
  "quartz-core": "/quartz-core/static-1.6267",
  "quick-fetch": "/quick-fetch/static-1.3924",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4664",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11160",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18012",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3325",
  "quartz-webpack": "/quartz-webpack/static-1.3272",
  "foundations-assets": "/foundations-assets/static-1.4877",
  "foundations-theming": "/foundations-theming/static-1.4430",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9997",
  "hubspotter-http": "/hubspotter-http/static-1.4659",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.232",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7258",
  "crm-message-bus": "/crm-message-bus/static-1.43038",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22279",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13039",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13176",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9837",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4012",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6801",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6896",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3593",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3853",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.990",
  "onboarding-tours": "/onboarding-tours/static-1.16637",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13730",
  "ui-addon-teams": "/ui-addon-teams/static-1.21571",
  "quartz-auth": "/quartz-auth/static-1.723",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9065",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9019",
  "ContentUtils": "/ContentUtils/static-1.68412",
  "customer-data-properties": "/customer-data-properties/static-1.51602",
  "forms-ai-lib": "/forms-ai-lib/static-1.4337",
  "forms-utils-lib": "/forms-utils-lib/static-1.12610",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5445",
  "react-dnd-compat": "/react-dnd-compat/static-1.4625",
  "react-tinymce": "/react-tinymce/static-1.55288",
  "tinymce-config": "/tinymce-config/static-2.54414",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10361",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3415",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3136",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.88",
  "ui-fonts": "/ui-fonts/static-1.744",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4338",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.713",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1552",
  "external-options-client-types": "/external-options-client-types/static-1.4166",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.723",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7938",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3709",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25428",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4891",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.987",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.478",
  "hs-story-utils": "/hs-story-utils/static-1.9436",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.237",
  "timezone-utils": "/timezone-utils/static-2.5256",
  "seat-types-lib": "/seat-types-lib/static-1.46",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4231",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1980",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.723",
  "quartz-tracking": "/quartz-tracking/static-1.427",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.74",
  "chirp-fetch": "/chirp-fetch/static-1.1898",
  "purchase-motions-components": "/purchase-motions-components/static-1.5926",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4086",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2913",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.163",
  "pulse": "/pulse/static-1.586",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.918",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3804",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4145",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.15",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3698",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18507",
  "growth-data-modal": "/growth-data-modal/static-1.5448",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3078",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1968",
  "navigation-components": "/navigation-components/static-1.18079",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4851",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.703",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10176",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7557",
  "ui-universal-auth": "/ui-universal-auth/static-1.8992",
  "user-context": "/user-context/static-1.5116",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9995",
  "magpie-lib": "/magpie-lib/static-1.5559",
  "navigation-messaging": "/navigation-messaging/static-1.7406",
  "chatspot-core": "/chatspot-core/static-1.21398",
  "copilot-toolkit": "/copilot-toolkit/static-1.11173",
  "cms-field-types": "/cms-field-types/static-1.4824",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16199",
  "calling-global-api": "/calling-global-api/static-1.64562",
  "calling-internal-common": "/calling-internal-common/static-1.31314",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65944",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58238",
  "commerce-products-lib": "/commerce-products-lib/static-1.9623",
  "crm-links": "/crm-links/static-1.6304",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9324",
  "file-manager-components": "/file-manager-components/static-1.23666",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4230",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.643",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48798",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3972",
  "property-value-citations": "/property-value-citations/static-1.2216",
  "smart-property-lib": "/smart-property-lib/static-1.7145",
  "tiered-pricing": "/tiered-pricing/static-1.1249",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9069",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19857",
  "tinymce-themes": "/tinymce-themes/static-1.56384",
  "data-token-picker": "/data-token-picker/static-1.16430",
  "hub-http-contrib": "/hub-http-contrib/static-1.3054",
  "interframe": "/interframe/static-3.4770",
  "tinymce-data": "/tinymce-data/static-1.40499",
  "tinymce-plugins": "/tinymce-plugins/static-1.57528",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5222",
  "onboarding-scopes": "/onboarding-scopes/static-1.6472",
  "ui-addon-opt": "/ui-addon-opt/static-4.8377",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4663",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.350",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.184",
  "purchase-motions-api": "/purchase-motions-api/static-1.5929",
  "trials-service-types": "/trials-service-types/static-1.3914",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.89",
  "directed-graph": "/directed-graph/static-1.947",
  "event-emitter": "/event-emitter/static-1.958",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1976",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1996",
  "user-context-client": "/user-context-client/static-1.4624",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5019",
  "nest": "/nest/static-1.239",
  "reactive-lib": "/reactive-lib/static-1.736",
  "simple-logging-lib": "/simple-logging-lib/static-1.3061",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.788",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17625",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13614",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5612",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7792",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10376",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.506",
  "calling-error-reporting": "/calling-error-reporting/static-1.31321",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11048",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6553",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1025",
  "customer-data-tracking": "/customer-data-tracking/static-1.6901",
  "commerce-permissions": "/commerce-permissions/static-1.780",
  "products-iframe-lib": "/products-iframe-lib/static-1.7982",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10379",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9310",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4166",
  "video-components-external": "/video-components-external/static-1.11325",
  "video-data-lib": "/video-data-lib/static-1.34983",
  "data-agent-kit": "/data-agent-kit/static-1.212",
  "feedback-loader": "/feedback-loader/static-1.29318",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10080",
  "fsm": "/fsm/static-1.3742",
  "policy-lib": "/policy-lib/static-1.6789",
  "react-colorpicker": "/react-colorpicker/static-2.10218",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10143",
  "FileManagerLib": "/FileManagerLib/static-1.39306",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9065",
  "FileManagerCore": "/FileManagerCore/static-1.39165",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7771",
  "layout-dnd-components": "/layout-dnd-components/static-1.12470",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11445",
  "react-codemirror": "/react-codemirror/static-1.10638",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9899",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15331",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14859",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7617",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3024",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.288",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.411",
  "slack-ui-library": "/slack-ui-library/static-1.10404",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35802",
  "sales-views-client-types": "/sales-views-client-types/static-1.4270",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3604",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12368",
  "content-media-compositions": "/content-media-compositions/static-2.16375",
  "media-bridge-lib": "/media-bridge-lib/static-1.18950",
  "trellis-story-utils": "/trellis-story-utils/static-1.4526",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5933",
  "FileManagerImages": "/FileManagerImages/static-1.36817",
  "video-components": "/video-components/static-1.13328",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4548",
  "video-embed": "/video-embed/static-1.35817",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8713",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28607",
  "ContentData": "/ContentData/static-1.68487",
  "layout-data-lib": "/layout-data-lib/static-1.9770",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22161",
  "outpost": "/outpost/static-1.4193",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6592",
  "advanced-menus-core": "/advanced-menus-core/static-1.15147",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12086",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34092",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15146",
  "simple-menus-lib": "/simple-menus-lib/static-1.16663"
}
};
